import p1 from './assets/Animal Printed Shirt.png'
import p2 from './assets/Knit Cream Sweater.png'
import p3 from './assets/Men\'s Waistcoat.png'
import p4 from './assets/Miss Chase Bodycon Dress.png'
import p5 from './assets/Plain Round Neck T-shirt.png'
import p6 from './assets/Polyester Saree.png'
import p7 from './assets/Sheer Anarkali.png'
import p8 from './assets/Slim Fit Blazer.png'
import p9 from './assets/Slim Fit Jeans.png'
import p10 from './assets/Warm Up Jacket.png'
import p11 from './assets/Wide Bowknot Hat.png'
import p12 from './assets/Wrap Dress.png'
import p13 from './assets/Zari Design Kurta.png'

import p14 from './assets/Analog Men\'s Watch.png'
import p15 from './assets/Chronograph black Watch.png'
import p16 from './assets/Lightweight Tripod.png'
import p17 from './assets/Maritime Men\'s Watch.png'
import p18 from './assets/Neutra Analog Men\'s Watch.png'
import p19 from './assets/Podcast Microphone.png'
import p20 from './assets/Privateer Quartz Watch.png'
import p21 from './assets/PS5 Controller Charger.png'
import p22 from './assets/Tripod Stand.png'
import p23 from './assets/True Wireless Earbuds.png'

import p24 from './assets/Aluminium 4 Cup Tea Kettle.png'
import p25 from './assets/Mixer Grinder (White).png'
import p26 from './assets/Beard Trimmer.png'
import p27 from './assets/Front Load Machine.png'
import p28 from './assets/Hair Dryer.png'
import p29 from './assets/Handheld Full Body Massager.png'
import p30 from './assets/Mixer Grinder.png'
import p31 from './assets/Nova SuperGroom Multi-kit.png'
import p32 from './assets/Tea Kettle Pot.png'

import p33 from './assets/Minifigures.png'
import p34 from './assets/Batman Batmobile.png'
import p35 from './assets/Bot Robot Toy.png'
import p36 from './assets/Honey Teddy Bear.png'
import p37 from './assets/Kids Toy Train.png'
import p38 from './assets/Knitted Rabbit.png'
import p39 from './assets/Monsters Charm Toy.png'
import p40 from './assets/Nexa Yellow Car.png'
import p41 from './assets/Non-Toxic Robot Toys.png'
import p42 from './assets/Panda Baby Product.png'

import p43 from './assets/Basmati Rice.png'
import p44 from './assets/Chilli Extract Sauce.png'
import p45 from './assets/Maroon Kumkum.png'
import p46 from './assets/Turmeric Powder.png'
import p47 from './assets/Virgin Avocado Oil.png'

export const localProductsList = [
  { id: '1', title: 'Animal Printed Shirt', brand: 'Majestic Man', price: 1399, rating: 3.2, imageUrl: p1, category: 'Clothing' },
  { id: '2', title: 'Knit Cream Sweater', brand: 'H&M', price: 1499, rating: 2.5, imageUrl: p2, category: 'Clothing' },
  { id: '3', title: 'Men\'s Waistcoat', brand: 'Raymond', price: 2199, rating: 4.3, imageUrl: p3, category: 'Clothing' },
  { id: '4', title: 'Miss Chase Bodycon Dress', brand: 'Miss Chase', price: 1899, rating: 4.6, imageUrl: p4, category: 'Clothing' },
  { id: '5', title: 'Plain Round Neck T-shirt', brand: 'Zara', price: 599, rating: 1.5, imageUrl: p5, category: 'Clothing' },
  { id: '6', title: 'Polyester Saree', brand: 'Biba', price: 2999, rating: 4.8, imageUrl: p6, category: 'Clothing' },
  { id: '7', title: 'Sheer Anarkali', brand: 'FabIndia', price: 3499, rating: 4.4, imageUrl: p7, category: 'Clothing' },
  { id: '8', title: 'Slim Fit Blazer', brand: 'Arrow', price: 4599, rating: 2.7, imageUrl: p8, category: 'Clothing' },
  { id: '9', title: 'Slim Fit Jeans', brand: 'Levi\'s', price: 2499, rating: 1.5, imageUrl: p9, category: 'Clothing' },
  { id: '10', title: 'Warm Up Jacket', brand: 'Puma', price: 1199, rating: 4.1, imageUrl: p10, category: 'Clothing' },
  { id: '11', title: 'Wide Bowknot Hat', brand: 'Accessorize', price: 899, rating: 3.6, imageUrl: p11, category: 'Clothing' },
  { id: '12', title: 'Wrap Dress', brand: 'Vero Moda', price: 1499, rating: 4.2, imageUrl: p12, category: 'Clothing' },
  { id: '13', title: 'Zari Design Kurta', brand: 'Manyavar', price: 1999, rating: 4.0, imageUrl: p13, category: 'Clothing' },

  { id: '14', title: 'Analog Men\'s Watch', brand: 'Titan', price: 3299, rating: 4.5, imageUrl: p14, category: 'Electronics' },
  { id: '15', title: 'Chronograph black Watch', brand: 'Fossil', price: 7399, rating: 4.3, imageUrl: p15, category: 'Electronics' },
  { id: '16', title: 'Lightweight Tripod', brand: 'Digitek', price: 850, rating: 2.0, imageUrl: p16, category: 'Electronics' },
  { id: '17', title: 'Maritime Men\'s Watch', brand: 'Casio', price: 4200, rating: 4.9, imageUrl: p17, category: 'Electronics' },
  { id: '18', title: 'Neutra Analog Men\'s Watch', brand: 'Fossil', price: 8499, rating: 4.8, imageUrl: p18, category: 'Electronics' },
  { id: '19', title: 'Podcast Microphone', brand: 'Blue Yeti', price: 11900, rating: 3.9, imageUrl: p19, category: 'Electronics' },
  { id: '20', title: 'Privateer Quartz Watch', brand: 'Fossil', price: 6990, rating: 4.7, imageUrl: p20, category: 'Electronics' },
  { id: '21', title: 'PS5 Controller Charger', brand: 'Sony', price: 2490, rating: 4.8, imageUrl: p21, category: 'Electronics' },
  { id: '22', title: 'Tripod Stand', brand: 'Syvo', price: 600, rating: 2.6, imageUrl: p22, category: 'Electronics' },
  { id: '23', title: 'True Wireless Earbuds', brand: 'boAt', price: 1299, rating: 1.5, imageUrl: p23, category: 'Electronics' },

  { id: '24', title: 'Aluminium 4 Cup Tea Kettle', brand: 'Prestige', price: 850, rating: 4.4, imageUrl: p24, category: 'Appliances' },
  { id: '25', title: 'Mixer Grinder (White)', brand: 'Bajaj', price: 2200, rating: 4.3, imageUrl: p25, category: 'Appliances' },
  { id: '26', title: 'Beard Trimmer', brand: 'Philips', price: 1500, rating: 3.2, imageUrl: p26, category: 'Appliances' },
  { id: '27', title: 'Front Load Machine', brand: 'Samsung', price: 28000, rating: 4.6, imageUrl: p27, category: 'Appliances' },
  { id: '28', title: 'Hair Dryer', brand: 'Havells', price: 950, rating: 2.5, imageUrl: p28, category: 'Appliances' },
  { id: '29', title: 'Handheld Full Body Massager', brand: 'Agaro', price: 1200, rating: 4.3, imageUrl: p29, category: 'Appliances' },
  { id: '30', title: 'Mixer Grinder', brand: 'Butterfly', price: 3100, rating: 3.1, imageUrl: p30, category: 'Appliances' },
  { id: '31', title: 'Nova SuperGroom Multi-kit', brand: 'Nova', price: 1100, rating: 4.7, imageUrl: p31, category: 'Appliances' },
  { id: '32', title: 'Tea Kettle Pot', brand: 'Milton', price: 650, rating: 1.8, imageUrl: p32, category: 'Appliances' },

  { id: '33', title: 'Minifigures', brand: 'Lego', price: 499, rating: 1.0, imageUrl: p33, category: 'Toys' },
  { id: '34', title: 'Batman Batmobile', brand: 'Hot Wheels', price: 1200, rating: 4.2, imageUrl: p34, category: 'Toys' },
  { id: '35', title: 'Bot Robot Toy', brand: 'Zest', price: 1800, rating: 1.0, imageUrl: p35, category: 'Toys' },
  { id: '36', title: 'Honey Teddy Bear', brand: 'Hamleys', price: 1450, rating: 4.5, imageUrl: p36, category: 'Toys' },
  { id: '37', title: 'Kids Toy Train', brand: 'Fisher-Price', price: 850, rating: 1.4, imageUrl: p37, category: 'Toys' },
  { id: '38', title: 'Knitted Rabbit', brand: 'SoftDreams', price: 599, rating: 4.7, imageUrl: p38, category: 'Toys' },
  { id: '39', title: 'Monsters Charm Toy', brand: 'Funko', price: 650, rating: 4.6, imageUrl: p39, category: 'Toys' },
  { id: '40', title: 'Nexa Yellow Car', brand: 'Centy', price: 350, rating: 2.2, imageUrl: p40, category: 'Toys' },
  { id: '41', title: 'Non-Toxic Robot Toys', brand: 'Playgro', price: 1100, rating: 4.3, imageUrl: p41, category: 'Toys' },
  { id: '42', title: 'Panda Baby Product', brand: 'MeeMee', price: 450, rating: 4.8, imageUrl: p42, category: 'Toys' },

  { id: '43', title: 'Basmati Rice', brand: 'India Gate', price: 650, rating: 3.9, imageUrl: p43, category: 'Grocery' },
  { id: '44', title: 'Chilli Extract Sauce', brand: 'Kissan', price: 150, rating: 3.1, imageUrl: p44, category: 'Grocery' },
  { id: '45', title: 'Maroon Kumkum', brand: 'Patanjali', price: 50, rating: 4.4, imageUrl: p45, category: 'Grocery' },
  { id: '46', title: 'Turmeric Powder', brand: 'Everest', price: 120, rating: 1.7, imageUrl: p46, category: 'Grocery' },
  { id: '47', title: 'Virgin Avocado Oil', brand: 'Disano', price: 850, rating: 4.6, imageUrl: p47, category: 'Grocery' }
]